import AddIcon from "@mui/icons-material/Add";

import UploadedFile from "@musicfy/components/UploadedFile";
import { type IFileUpload } from "@musicfy/utils/hooks/useStorage";

interface UploadedInferenceFilesListProps {
  uploadedFiles: IFileUpload[];
  uploadProgress: { [key: string]: number };
  onDelete?: (path: string) => void;
  onAddMoreFilesClick?: () => void;
}

const UploadedInferenceFilesList = ({
  uploadedFiles,
  uploadProgress,
  onDelete,
  onAddMoreFilesClick,
}: UploadedInferenceFilesListProps): JSX.Element => {
  return (
    <div
      className="flex flex-col gap-3 lg:gap-4"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {uploadedFiles.map((uploadedFile, index) => {
        const progress = uploadProgress[uploadedFile.path] ?? 0;

        return (
          <UploadedFile
            uploadProgress={progress}
            key={uploadedFile.path}
            uploadedFile={uploadedFile}
            index={index}
            onDelete={() => onDelete?.(uploadedFile.path)}
          />
        );
      })}
      <div className="flex justify-center items-center mt-2 lg:mt-0">
        <div
          className="flex cursor-pointer items-center gap-6"
          onClick={(e) => {
            e.stopPropagation();
            onAddMoreFilesClick?.();
          }}
        >
          <div className="w-12 h-12 flex items-center justify-center text-pink-200 rounded-4 border border-white/20 bg-gray-1000/20">
            <AddIcon />
          </div>
          <span className="text-white text-20 lg:text-28">
            Upload More Audio
          </span>
        </div>
      </div>
    </div>
  );
};

export default UploadedInferenceFilesList;
